import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { WebsiteLayout } from '@/components/website/WebsiteLayout';
import { Building2, MapPin, ArrowRight } from 'lucide-react';
import api from '@/utils/api';

export default function ProjectsPage() {
  const [properties, setProperties] = useState([]);

  useEffect(() => {
    api.get('/public/properties').then(r => setProperties(r.data || [])).catch(() => {});
  }, []);

  return (
    <WebsiteLayout>
      <Helmet>
        <title>Our Projects | Ganesa Homestate Developers</title>
        <meta name="description" content="Explore all projects by Ganesa Homestate Developers - Premium plots, flats, villas and commercial properties across prime locations." />
      </Helmet>

      <section className="bg-[#0A0A0F] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <span className="text-[#DAA520] text-sm font-semibold uppercase tracking-wider">Our Projects</span>
          <h1 className="text-4xl sm:text-5xl font-bold text-white mt-3">Ongoing & Completed <span className="text-[#DAA520]">Projects</span></h1>
        </div>
      </section>

      <section className="py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          {properties.length > 0 ? (
            <div className="space-y-8">
              {properties.map((p, i) => (
                <Link key={p.id} to={`/properties/${p.id}`} className="group block bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-slate-100">
                  <div className="grid md:grid-cols-3 gap-0">
                    <div className="h-48 md:h-full bg-gradient-to-br from-[#1A1A25] to-[#0A0A0F] flex items-center justify-center min-h-[200px]">
                      <Building2 size={48} className="text-[#DAA520]/20" />
                    </div>
                    <div className="md:col-span-2 p-8">
                      <span className="text-[#DAA520] text-xs font-bold uppercase tracking-wider">{p.property_type || 'Project'}</span>
                      <h2 className="text-2xl font-bold text-[#0A0A0F] mt-2 mb-3 group-hover:text-[#DAA520] transition-colors">{p.property_name}</h2>
                      <div className="flex items-center gap-2 text-slate-500 text-sm mb-4">
                        <MapPin size={16} className="text-[#DAA520]" /> {p.location || 'Prime Location'}
                      </div>
                      <p className="text-slate-600 text-sm mb-5 line-clamp-2">{p.description || 'Premium property with modern amenities and excellent connectivity.'}</p>
                      <div className="flex items-center gap-6">
                        {p.total_area && <div><span className="text-xs text-slate-400">Total Area</span><div className="font-bold text-[#0A0A0F]">{p.total_area}</div></div>}
                        {p.total_units && <div><span className="text-xs text-slate-400">Units</span><div className="font-bold text-[#0A0A0F]">{p.total_units}</div></div>}
                        {p.price_range && <div><span className="text-xs text-slate-400">Starting From</span><div className="font-bold text-[#DAA520]">{p.price_range}</div></div>}
                      </div>
                      <div className="mt-5 flex items-center text-sm font-semibold text-[#DAA520] group-hover:gap-3 gap-2 transition-all">
                        View Project Details <ArrowRight size={16} />
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <Building2 size={48} className="mx-auto text-slate-300 mb-4" />
              <h3 className="text-xl font-bold text-[#0A0A0F] mb-2">Projects Coming Soon</h3>
              <p className="text-slate-500">We're preparing exciting new projects. Contact us for upcoming launches.</p>
            </div>
          )}
        </div>
      </section>
    </WebsiteLayout>
  );
}
